/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCoachDto } from '../models/CreateCoachDto';
import type { CreateSportsClubDto } from '../models/CreateSportsClubDto';
import type { RegistrationResponseDto } from '../models/RegistrationResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegistrationService {
    /**
     * Register a new sports club
     * Creates a new sports club account with optional initial team
     * @param formData
     * @returns RegistrationResponseDto Sports club successfully created
     * @throws ApiError
     */
    public static registerSportsClub(
        formData?: {
            data: CreateSportsClubDto;
            image?: Blob;
        },
    ): CancelablePromise<RegistrationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/register/sports-club',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Invalid input or username/REGON already exists`,
            },
        });
    }
    /**
     * Validate a coach invitation token
     * @param token
     * @returns InvitationValidationResponseDto
     * @throws ApiError
     */
    public static validateInvitationToken(
        token: string,
    ): CancelablePromise<{
        valid: boolean;
        email?: string;
        sportsClubName?: string;
        sportsClubId?: number;
        userAlreadyExists?: boolean;
        teams?: Array<{ teamId: number; teamName: string; tier?: string }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/register/validate-invitation',
            query: {
                'token': token,
            },
        });
    }
    /**
     * Accept a coach invitation (existing user)
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static acceptInvitation(
        requestBody: { token: string; teamIds: Array<number> },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/register/accept-invitation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Register a new coach
     * Creates a new coach account with licenses and availability information
     * @param formData
     * @returns RegistrationResponseDto Coach successfully created
     * @throws ApiError
     */
    public static registerCoach(
        formData?: {
            data: CreateCoachDto;
            image?: Blob;
        },
    ): CancelablePromise<RegistrationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/register/coach',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Invalid input or username already exists`,
            },
        });
    }
}
